export default __webpack_public_path__ + "static/media/img6.01f70ceb.jpg";